import { type Components, type Theme } from "@mui/material";

export const muiCheckboxOverrides: Components<Theme> = {
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
    },
  },
};
